import {keyGen} from '../keygen';
import { Dbx } from '../dbx';

// const onLocalHost = ["localhost", "127.0.0.1", ""].includes(window.location.hostname);

const resolve = (db, path) => {
    const keys = path.split('/');
    let endpoint = undefined;

    keys.forEach((key, index) => {
        if (index === 0) {
            endpoint = db.collection(key);
        }
        else {
            endpoint = (index % 2) ? endpoint.doc(key) : endpoint.collection(key);
        }
    })

    return {endpoint, type: keys.length % 2 ? 'collection' : 'document'};
}

const unpack = (snapshot, unarchive) => {
    const items = [];
    const showArchived = Boolean(Dbx.read('show_archived')) || unarchive;

    snapshot.forEach(item => {
        // console.log('item', item.ref.path)
        if (showArchived || !item.data().archived) {
            items.push({
                ...item.data(),
                id: item.id,
                _docPath: item.ref.path
            })
        }
    })

    return items;
}

const subscriptions = new Map();
const subscribers = new Map();

const subscribe = ({db, path, hook, context}) => {
    // if (onLocalHost) {
    //     console.log('db: subscribe', { path, context });
    // }

    if (/undefined/.test(path)) console.log('db subscribe', path);

    const id = keyGen(5);

    if (!subscribers.has(path)) {
        subscribers.set(path, new Map());
    }

    subscribers.get(path).set(id, hook);

    const {endpoint, type} = resolve(db, path); 
    
    if (!subscriptions.has(path)) {

        const cancel = endpoint.onSnapshot(state => {
            const data = type === 'collection' ? unpack(state) : state.data();
            
            subscribers.get(path)?.forEach((fn) => {
                fn(data);
            })
        })
    
        subscriptions.set(path, {cancel} );
    }
    else {
        endpoint.get().then(state => {
            const data = type === 'collection' ? unpack(state) : state.data();
            hook(data);
        }) 
    }

    return () => unsubscribe({path, id});
}

const unsubscribe = ({path, id}) => {
    const subs = subscribers.get(path);

    if (!subs) return;

    if (subs.has(id)) {
        subs.delete(id);
    }

    if (subs.length === 0 && subscriptions.has(path)) {
        subscriptions.get(path).cancel();
        subscriptions.delete(path);
    }
}

const unsubscribeAll = () => {
    subscriptions.forEach((value) => {
        value.cancel();
    })
    subscriptions.clear();
    subscribers.clear();
}


export {resolve, subscribe, unpack, unsubscribeAll }